import './App.css';

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Home from './pages/Home.jsx'
import RegistrationPage from './pages/RegistrationPage.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/register">
            <RegistrationPage />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>

  );
}

export default App;
